import React, { useState, useEffect } from "react";
import { Table } from "reactstrap";
import { useParams } from "react-router-dom";
import tutorsModal from "models/tutors.modal";

const TeachingExperiences = ({setTeachingExperienceIndication}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const params = useParams();

  const getListDataById = async () => {
    setIsLoading(true);
    
    // Dummy data to replace API call
    const dummyData = [
      {
        _id: "1",
        type: "School",
        name: "Delhi Public School",
        designation: "Senior Teacher",
        start_year: "2020",
        end_year: "2023",
        duration: "3 years",
        working: false,
        classes: "Class 9-12",
        board: "CBSE",
        subjects: "Physics, Mathematics",
        about: "Taught advanced physics and mathematics to senior students"
      },
      {
        _id: "2",
        type: "Coaching Institute",
        name: "Aakash Institute",
        designation: "Subject Expert",
        start_year: "2023",
        end_year: "-",
        duration: "1 year",
        working: true,
        classes: "Class 11-12",
        board: "CBSE/JEE",
        subjects: "Physics",
        about: "Currently teaching JEE preparation physics"
      },
      {
        _id: "3",
        type: "Private Tuition",
        name: "Home Tuition",
        designation: "Private Tutor",
        start_year: "2019",
        end_year: "2020",
        duration: "1 year",
        working: false,
        classes: "Class 8-10",
        board: "ICSE",
        subjects: "Science, Mathematics",
        about: "Provided personalized home tuition for middle school students"
      }
    ];
    
    setTimeout(() => {
      setIsLoading(false);
      setDataList(dummyData);
      if(dummyData.length > 0){
        setTeachingExperienceIndication(true);
      } else {
        setTeachingExperienceIndication(false);
      }
    }, 1000);
  };

  useEffect(() => {
    if (params.mid !== "") {
      getListDataById();
    }
  }, [params.mid]);

  const handleDownload = (url) => {
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.focus();
    } else {
      console.error("Popup blocked. Please enable popups and try again.");
    }
  };

  return (
    <div>
      <div style={{ overflowX: "auto" }}>
        <Table hover>
          <thead>
            <tr style={{ background: "#F6F9FC" }}>
              <th id="tableheding">S.NO</th>
              <th id="tableheding">Type</th>
              <th id="tableheding">Company Name</th>
              <th id="tableheding">Designation</th>
              <th id="tableheding">Start Year</th>
              <th id="tableheding">End Year</th>
              <th id="tableheding">Duration</th>
              <th id="tableheding">Currently working status</th>
              <th id="tableheding">Classes</th>
              <th id="tableheding">Board</th>
              <th id="tableheding">Subjects</th>
              <th id="tableheding">About</th>
             
            </tr>
          </thead>
          <tbody>
            {!isLoading ? (
              dataList?.length > 0 ? (
                dataList.map((item, index) => (
                  <tr key={item._id} style={{ cursor: "pointer" }}>
                    <td id="tabledata">{index + 1}</td>
                    <td id="tabledata">{item?.type || "-"}</td>
                    <td id="tabledata">{item?.name || "-"}</td>
                    <td id="tabledata">{item?.designation || "-"}</td>
                    <td id="tabledata">{item?.start_year || "-"}</td>
                    <td id="tabledata">{item?.end_year || "-"}</td>
                    <td id="tabledata">{item?.duration || "-"}</td>
                    {/* <td>{item?.working}</td> */}
                    <td id="tabledata">
  {item?.working !== undefined && item?.working !== null 
    ? item.working 
      ? "Yes" 
      : "No" 
    : "-"}
</td>

                    
                    <td id="tabledata">{item?.classes || "-"}</td>
                    <td id="tabledata">{item?.board || "-"}</td>
                    <td id="tabledata">{item?.subjects || "-"}</td>
                    <td id="tabledata">{item?.about || "-"}</td>
                  
                  </tr>
                ))
              ) : (
                <tr style={{ textAlign: "center" }}>
                  <td colSpan="12" style={{ verticalAlign: "middle" }}>
                    No data found
                  </td>
                </tr>
              )
            ) : (
              <tr style={{ textAlign: "center" }}>
                <td colSpan="12" style={{ verticalAlign: "middle" }}>
                  Loading...
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <br />
    </div>
  );
};

export default TeachingExperiences;
